import { render, staticRenderFns } from "./EditAvatarComponent.vue?vue&type=template&id=5085c82c"
import script from "./EditAvatarComponent.vue?vue&type=script&lang=js"
export * from "./EditAvatarComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports